import logo from '../assets/atad-logo-bars.png';

interface LoadingSpinnerProps {
  message?: string;
  className?: string;
}

export default function LoadingSpinner({
  message,
  className,
}: LoadingSpinnerProps) {
  return (
    <div
      className={`mx-auto mt-4 flex flex-col justify-center items-center ${
        className ? className : ''
      }`}
    >
      <img
        className="w-16 h-16 mb-2 motion-safe:animate-bounce"
        src={logo}
        alt="loading indicator"
      />
      {message && <p>{message}</p>}
    </div>
  );
}
